'use client'

import dynamic from 'next/dynamic'

export const MSWBoundary = dynamic(async () => {
	if (
		process.env.NODE_ENV === 'development' &&
		process.env.NEXT_PUBLIC_MSW === 'enable'
	) {
		const { MSWWrapper } = await import('mocks-data/MSWWrapper')
		return MSWWrapper
	}

	return Promise.resolve(({ children }: { children: React.ReactNode }) => (
		<>{children}</>
	))
})
